<template>
  <div class="popup z-index-10-fg confirmation small-popup confirm-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Leave Page</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="closeConfirm()" />
      </div>
      <div class="popup-body">
        <p>You have unsaved work. By navigating away you will lose the information you just typed. Do you want to save the changes first?</p>
      </div>
      <div class="popup-footer">
        <button @click="goAhead($router)" class="text-btn">Don't Save</button>
        <button @click="cancelConfirm()" class="square-btn">Save First</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useSaveProtect from '@/composables/useSaveProtect';

export default {
  name: 'LeavePageConfirmation',
  setup() {
    const { cancelConfirm, goAhead, closeConfirm } = useSaveProtect();

    return {
      cancelConfirm,
      goAhead,
      closeConfirm,
    };
  },
};
</script>

<style lang="scss" scoped>
.confirm-popup {
  width: 25rem;
}
</style>
